import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import bootstrap from 'bootstrap';
import Global from 'models/Global';
import SessionCalendarView from 'views/SessionCalendarView';
import Config from 'config';
import moment from 'moment';

var CalendarView = Backbone.View.extend({

    events: {

    },

    initialize: function(options) {
        _.bindAll(this, 'renderCalendar');
        this.parseSessions();

        this.listenTo(this.model.get('track'), 'change:disabled', this.renderCalendar);
    },

    parseSessions: function() {
        this.events = [];
        var thisView = this;
        this.model.get('session').each(function(session) {
            if (session.hasVisibleTracks()) {
                thisView.events.push({
                    title: session.get('name') + '', // Force title to be string to avoid fullCalendar bug
                    start: moment(session.get('startDate')),
                    end: moment(session.get('startDate')).add(session.get('duration'), 'm'),
                    className: 'session-calendar',
                    model: session,
                    allDay: false,
                    url: Global.get('event').getUrlPrefix() + '/agenda/session/' + session.get('id')
                });
            }
        });

        var firstSession = this.model.get('session').at(0);
        var lastSession = this.model.get('session').last();
        this.firstHourOfDay = firstSession && moment(firstSession.get('start'), 'HH:mm').hours();
        this.lastSessionTime = lastSession && moment(lastSession.get('start'), 'HH:mm').add(lastSession.get('duration'), 'm');
        this.lastHourOfDay = this.lastSessionTime.hours();
        if (this.lastSessionTime.minutes() > 0) {
            this.lastHourOfDay += 1;
        }
    },

    remove: function() {
        this.$el.fullCalendar('destroy');
        return Backbone.View.prototype.remove.call(this);
    },

    renderCalendar: _.debounce( function() {
        this.$el.fullCalendar('destroy');
        this.parseSessions();
        this.render();
    }, 0),

    render: function() {
        this.$el.fullCalendar({
            defaultView: 'agendaDay',
            minTime: this.firstHourOfDay + ':00:00',
            maxTime: this.lastHourOfDay + ':00:00',
            axisFormat: 'h:mma',
            header: false,
            height: 'auto',
            defaultDate: moment(this.model.get('startDate')),
            events: this.events,
            slotDuration: '00:05:00',
            allDaySlot: false,
            eventRender: function(event, element) {
                new SessionCalendarView({
                    model: event.model,
                    el: $(element)
                }).render();
            }
        });
        return this;
    }

});

export default CalendarView;


